export default __webpack_public_path__ + "static/media/zomLogo.d3e9c4eb.png";